module.exports = __webpack_public_path__ + "static/img/title.e9779e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login/title.png
// module id = eaWz
// module chunks = 0